import { ComponentLibrary } from '@juntossomosmais/atomium/vue'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin(() => {
  ComponentLibrary.install()
})
